<template>
  <div id="reportcountdown">
    <div class="areaBlock">
      <p class="title">
        {{$t('reportcountdown.title')}}
      </p>
      <el-switch
        v-model="countdownEnabled"
        :active-text="$t('reportcountdown.enabled')"
        :inactive-text="$t('reportcountdown.disabled')">
      </el-switch>
    </div>
    <div class="typeBlockSubmit">
      <el-button @click="submit" class="btn1 btn_blue_boder" type="primary" size="small">{{$t('normal_sure')}}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'reportcountdown',
  data () {
    return {
      doing: false,
      countdownEnabled: true,
      initConfs: null
    }
  },
  created () {
    this.initConf()
  },
  methods: {
    submit () {
      if (this.doing === true) {
        return false
      }
      let countdownValue = this.countdownEnabled ? 1 : 0
      console.log('countdownValue',countdownValue)
      console.log('initConfs.report_countdown_enabled',this.initConfs.report_countdown_enabled)
      if (countdownValue == this.initConfs.report_countdown_enabled) {
        this.$message(this.$i18n.t('reportcountdown').success || this.$i18n.t('datashowtype').success)
        return
      }
      let params = {
        reportcountdown: countdownValue == 1 ? 1 : 2
      }
      let dataLoadIng = this.openFullScreen()
      this.doing = true
      let _this = this
      this.axios.post('/skinMgrSrv/countdown/updateCountdown', this.formData(params)).then(function (response) {
        _this.doing = false
        if (response.data.code == 0) {
          _this.$message(_this.$i18n.t('reportcountdown').success || _this.$i18n.t('datashowtype').success)
          _this.initConfs = Object.freeze({
            report_countdown_enabled: countdownValue
          })
        } else {
          _this.$message(_this.$i18n.t('reportcountdown').fail || _this.$i18n.t('datashowtype').fail)
        }
        setTimeout(() => {
          dataLoadIng.close()
        }, 300);
      }).catch(function(res){
        _this.doing = false
        console.log(res)
        setTimeout(() => {
          dataLoadIng.close()
        }, 300);
      });
    },
    initConf () {
      if (this.doing === true) {
        return false
      }
      let dataLoadIng = this.openFullScreen()
      this.doing = true
      let _this = this
      this.axios
        .post("/skinMgrSrv/countdown/getCountdown", this.formData({}))
        .then(function(response) {
          _this.doing = false;
          if (response.data.code === 0) {
            if (response.data.reportcountdown) {
              _this.countdownEnabled = response.data.reportcountdown == 'true'?true:false
              _this.initConfs = Object.freeze({
                report_countdown_enabled: response.data.reportcountdown == 'true'?1:0
              })
            } else {
              // 如果服务器没有返回配置，使用默认值 true
              _this.countdownEnabled = true
              _this.initConfs = Object.freeze({
                report_countdown_enabled: 2
              })
            }
          }
          setTimeout(() => {
            dataLoadIng.close()
          }, 300);
        }).catch(function (res) {
          _this.doing = false;
          console.error(res)
          setTimeout(() => {
            dataLoadIng.close()
          }, 300);
        });
    }
  }
}
</script>
<style lang="scss">
  #reportcountdown{
    width: calc(100% - 40px);
    height: auto;
    background-color: #fff;
    margin: 20px;
    border-radius: 5px;
    padding-top: 60px;
    .areaBlock{
      width: calc(100% - 200px);
      margin: 15px 100px;
      display: flex;
      align-items: center;
      .title {
        font-size: 14px;
        margin-right: 20px;
        font-weight: 500;
        text-align: left;
      }
    }
    .typeBlockSubmit{
      width: calc(100% - 200px);
      height: 60px;
      text-align: left;
      margin: 60px 100px;
    }
    .btn_blue_boder{
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/config/reportcountdown.vue